import {
  captureException,
  configureScope,
  setUser as sentrySetUser,
  addBreadcrumb,
  User,
} from '@sentry/nextjs'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Extra } from '@sentry/types'

const trackError = (error: Error) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(error)
    return
  }

  captureException(error)
}

const setTag = (key: string, value: string) => {
  configureScope((scope) => {
    scope.setTag(key, value)
  })
}

const setExtra = (key: string, value: Extra) => {
  configureScope((scope) => {
    scope.setExtra(key, value)
  })
}

const setUser = (user: User | null) => {
  if (user) {
    sentrySetUser({ user })
  } else {
    // https://docs.sentry.io/platforms/javascript/guides/react/enriching-events/identify-user/
    configureScope((scope) => scope.setUser(null))
  }
}

export default {
  trackError,
  setTag,
  setExtra,
  setUser,
  addBreadcrumb,
}
